<div class="page-breadcrumbs">
  @let breadcrumbs = breadcrumbs$ | async;

  @if (breadcrumbs?.length) {
    @for (item of breadcrumbs; track getBreadcrumbTrackKey($index, item)) {
      <span>
        <a [routerLink]="getRouterLink(item.url)" [queryParams]="getQueryParams(item.url)" [title]="item.label">{{
          item.label
        }}</a>
      </span>
    }
  }

  @if (showCopyLink$ | async) {
    <button type="button" class="copy-link-btn" aria-label="Copy URL" matTooltip="Copy URL" (click)="copyUrl()">
      <ng-icon name="heroLinkMini" size="var(--size-4)" />
    </button>
  }
</div>
